import React, { useEffect, useRef, useState } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import './datepicker-custom-styles.css'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { StaticDatePicker } from '@mui/x-date-pickers'
import thLocale from 'date-fns/locale/th'
import OverwriteStaticFnsBE from './OverwriteStaticFnsBE'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

dayjs.extend(customParseFormat)

const FORMAT_DATETIME = 'YYYY-MM-DD HH:mm:ss'

const StaticDatePickerCustom = (props) => {
  const { formatDisplay, locale, value, onChange, setSelectTab } = props
  const pickerRef = useRef(null)
  const [view, setView] = useState()
  const [calendarValue, setCalendarValue] = useState(value)

  const handleChange = (date) => {
    setCalendarValue(date)
    let dateFormat = dayjs(date).format(FORMAT_DATETIME)
    if (onChange) {
      onChange({ value: date, format: dateFormat })
    }
    if (setSelectTab && view !== 'year') {
      setSelectTab('time')
    }
  }

  useEffect(() => {
    if (view === 'year') {
      const yearSelected = document.querySelector('.Mui-selected')
      if (yearSelected) {
        yearSelected.scrollIntoView({ block: 'center' })
      }
    }
  }, [view])

  return (
    <LocalizationProvider
      dateAdapter={
        formatDisplay.search('B') > -1 ? OverwriteStaticFnsBE : AdapterDateFns
      }
      adapterLocale={locale ?? thLocale}
    >
      <div ref={pickerRef}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={calendarValue}
          onChange={handleChange}
          onViewChange={(newView) => setView(newView)}
        />
      </div>
    </LocalizationProvider>
  )
}

export default StaticDatePickerCustom
